// src/components/EverydayWardrobe.jsx
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './EverydayWardrobe.css';

const EverydayWardrobe = () => {
  const [settings, setSettings] = useState({
    wardrobe_eyebrow: 'The Edit',
    wardrobe_title: 'Upgrade Your Everyday Wardrobe',
    wardrobe_description: 'From casual essentials to smart staples, find pieces made for daily confidence.',
    wardrobe_button_text: 'Start Shopping',
    wardrobe_image: 'https://images.unsplash.com/photo-1617137968427-85924c8006e2?w=800&h=600&fit=crop'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(prev => ({ ...prev, ...data.settings }));
      }
    } catch (error) {
      console.error('Error loading wardrobe settings:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="everyday-wardrobe">
      <div className="wardrobe-container">
        <div className="wardrobe-grid">
          <div className="wardrobe-image">
            <img
              src={settings.wardrobe_image}
              alt="Modern menswear"
              loading="lazy"
              className="wardrobe-img"
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/800x600?text=Wardrobe+Image';
              }}
            />
          </div>
          <div className="wardrobe-content">
            {settings.wardrobe_eyebrow && (
              <span className="wardrobe-eyebrow">{settings.wardrobe_eyebrow}</span>
            )}
            {settings.wardrobe_title && (
              <h2 className="wardrobe-title">{settings.wardrobe_title}</h2>
            )}
            {settings.wardrobe_description && (
              <p className="wardrobe-description">{settings.wardrobe_description}</p>
            )}
            <Link to="/shop" className="wardrobe-btn">
              {settings.wardrobe_button_text || 'Start Shopping'}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EverydayWardrobe;